import React from 'react';

const blankGif =
    'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';

const getHiResYoutubeImageUrl = (original: string | null) =>
    original?.match(/youtube/)
        ? original.replace(/\/0\.jpe?g$/i, '/maxresdefault.jpg')
        : original || blankGif;

const useHiResImage = (imgSrc: string | null) => {
    const [hiResImage, setHiResImage] = React.useState(
        getHiResYoutubeImageUrl(imgSrc),
    );

    // maxresdefault.jpg is not always available
    const fallback = () => {
        setHiResImage(imgSrc || blankGif);
    };

    React.useEffect(() => {
        setHiResImage(getHiResYoutubeImageUrl(imgSrc));
    }, [imgSrc]);

    return {
        hiResImage,
        fallback,
    };
};
export default useHiResImage;
